import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"

const Line = ({ tone, icon, label, value, href, unchecked }) => (
  <div className="flex items-center justify-between py-2 border-t border-slate-100 first:border-0">
    <div className="flex items-center gap-2.5 min-w-0">
      <span className={`shrink-0 w-6 h-6 grid place-items-center rounded-md ${tone}`}>
        <FontAwesomeIcon icon={icon} className="w-2.5 h-2.5" />
      </span>
      <span className="text-[12.5px] text-slate-700 truncate">{label}</span>
    </div>

    <div className="flex items-center gap-3 shrink-0">
      {unchecked ? (
        <span className="text-[12px] text-slate-400" title={I18n.t("contracts_dashboard.anomalies.unchecked_hint")}>
          {I18n.t("contracts_dashboard.anomalies.unchecked")}
        </span>
      ) : (
        <span className="text-[14px] font-bold tabular-nums text-slate-900">{value}</span>
      )}
      {!unchecked && value > 0 && href && (
        <a href={href} target="_blank" rel="noopener noreferrer"
           title={I18n.t("contracts_dashboard.anomalies.open_list")}
           className="text-[11.5px] font-semibold text-blue-600 hover:underline whitespace-nowrap">
          {I18n.t("contracts_dashboard.anomalies.see")}
          <FontAwesomeIcon icon="arrow-up-right-from-square" className="w-2 h-2 ml-1 opacity-60" />
        </a>
      )}
    </div>
  </div>
)

const AnomaliesCard = ({ quality, anomaliesUrl, partner }) => {
  if (!quality) return null

  // Sans calcul d'indexation, deux des trois compteurs ne veulent rien dire.
  const unchecked = quality.indexation_checked === false
  const clean = !unchecked && !quality.aberrant_count &&
                !quality.without_billing_plan && !quality.failing_indexation
  const t = (key) => I18n.t(`contracts_dashboard.anomalies.${key}`)
  const link = (type) => (anomaliesUrl ? `${anomaliesUrl}?type=${type}${partner ? `&partner=${partner}` : ""}` : null)

  return (
    <ChartCard
      icon     = "clipboard-check"
      title    = {I18n.t("contracts_dashboard.charts.anomalies")}
      subtitle = {I18n.t("contracts_dashboard.charts.anomalies_hint")}
      height   = {300}
    >
      <div className="px-5 py-3 overflow-auto h-full">
        {clean ? (
          <div className="h-full grid place-items-center text-[12.5px] text-slate-400">{t("none")}</div>
        ) : (
          <>
            <Line tone="bg-rose-50 text-rose-600" icon="triangle-exclamation"
                  label={t("aberrant")} value={quality.aberrant_count || 0}
                  href={link("aberrant")} unchecked={unchecked} />
            <Line tone="bg-amber-50 text-amber-600" icon="calendar-xmark"
                  label={t("no_billing_plan")} value={quality.without_billing_plan || 0} href={link("no_plan")} />
            <Line tone="bg-violet-50 text-violet-600" icon="percent"
                  label={t("failing_indexation")} value={quality.failing_indexation || 0}
                  href={link("failing")} unchecked={unchecked} />
          </>
        )}
      </div>
    </ChartCard>
  )
}

export default AnomaliesCard
